module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product productChoose"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [(_vm.dataOrder.order_info.product_image_url == null) ? _c('img', {
    attrs: {
      "src": 'https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png'
    }
  }) : _c('img', {
    staticClass: "img-table",
    attrs: {
      "src": _vm.dataOrder.order_info.product_image_url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('div', {
    staticClass: "price"
  }, [(isNaN(_vm.dataOrder.partial_price)) ? _c('span', [_c('span', {
    staticClass: "productName"
  }, [_vm._v("$ " + _vm._s(_vm.dataOrder.realPrice) + " ")])]) : (_vm.dataOrder.partial_price === 0) ? _c('span', [_c('span', {
    staticClass: "productName"
  }, [_vm._v("$ " + _vm._s(_vm.dataOrder.realPrice) + " ")])]) : _c('span', [_c('span', {
    staticStyle: {
      "text-decoration-line": "line-through",
      "color": "#716d68",
      "font-size": ".8em"
    }
  }, [_vm._v("$ " + _vm._s(_vm.dataOrder.realPrice))]), _vm._v(" "), (_vm.dataOrder.partial_price !== 0) ? _c('span', {
    staticStyle: {
      "color": "#716d68",
      "font-size": ".8em"
    }
  }, [_vm._v(" - $ " + _vm._s(_vm.dataOrder.partial_price))]) : _vm._e(), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "productCode"
  }, [_vm._v("#" + _vm._s(_vm.dataOrder.order_info.order_code))]), _vm._v(" "), _c('span', {
    staticClass: "productName"
  }, [_vm._v(_vm._s(_vm.dataOrder.order_info.weight_kg) + " Kg")]), _vm._v(" "), _c('span', {
    staticClass: "productName product-truncate bold"
  }, [_vm._v(_vm._s(_vm.dataOrder.order_info.product_info))])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    staticStyle: {
      "width": "35px"
    },
    attrs: {
      "type": "text",
      "numeric": "",
      "min": 1,
      "max": _vm.dataOrder.order_info.product_specimens
    },
    domProps: {
      "value": _vm.dataOrder.number_of_items
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cantidad2"
  }, [(isNaN(_vm.dataOrder.partial_price)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updatePrice),
      expression: "updatePrice"
    }],
    staticClass: "num ctrl-num",
    staticStyle: {
      "width": "80px",
      "height": "40px"
    },
    attrs: {
      "placeholder": 0,
      "type": "text"
    },
    domProps: {
      "value": (_vm.updatePrice)
    },
    on: {
      "keydown": function($event) {
        return _vm.noPuntoComa($event)
      },
      "keypress": _vm.onlyNumber,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.updatePrice = $event.target.value
      }, function($event) {
        return _vm.updatePrecio($event.target.value)
      }]
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updatePrice),
      expression: "updatePrice"
    }],
    staticClass: "num ctrl-num",
    staticStyle: {
      "width": "80px",
      "height": "40px"
    },
    attrs: {
      "placeholder": _vm.dataOrder.partial_price,
      "type": "text"
    },
    domProps: {
      "value": (_vm.updatePrice)
    },
    on: {
      "keydown": function($event) {
        return _vm.noPuntoComa($event)
      },
      "keypress": _vm.onlyNumber,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.updatePrice = $event.target.value
      }, function($event) {
        return _vm.updatePrecio($event.target.value)
      }]
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proAdd",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.alertQuitPackage
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32ad88d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/items/card-delete-orders.vue
// module id = 1866
// module chunks = 1